import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Package, Home, ClipboardList, AlertTriangle, Inbox, Users, Calendar as CalIcon } from 'lucide-react';

export function EmptyState({ title, description, cta, icon: Icon = Package, testId }) {
  return (
    <Card className="border-dashed">
      <CardContent className="flex flex-col items-center justify-center py-12 text-center" data-testid={testId}>
        <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-muted">
          <Icon className="h-6 w-6 text-muted-foreground" />
        </div>
        <div className="text-base font-semibold">{title}</div>
        {description && <div className="mt-1 max-w-md text-sm text-muted-foreground">{description}</div>}
        {cta && <div className="mt-4">{cta}</div>}
      </CardContent>
    </Card>
  );
}

export { Home, ClipboardList, AlertTriangle, Inbox, Users, CalIcon };
